import BlOverlayAv from './BlOverlayAv.vue'

BlOverlayAv.install = function(Vue) {
  Vue.component(BlOverlayAv.name, BlOverlayAv)
}

export default BlOverlayAv
